import React from 'react';
// import classNames from 'classnames';

// import styles from './Dropdown.css';

// export interface MenuItemProps {
//   // handleClick?: () => void;
//   // onClick?: (e: React.FormEvent<EventTarget>) => void;
//   onChange?: () => void;
// }

const MenuItem: React.FC<React.HTMLAttributes<HTMLLIElement>> = props => {
  const { children, /* onChange, */ ...restProps } = props;

  return <li /* onClick={onChange} */ {...restProps}>{children}</li>;
};

export default MenuItem;
